/**
 * Extras include Filter, used for filtering extras for display and extra categories based on included rates
 */
bookingApp.filter('extrasInclude',['$filter',function() {
    var extrasFilter = function (input, ratesInCart, roomRate) {
        var out = [];
        extrasFound = [];
        angular.forEach(input, function (extra) {
            if((typeof extra.includedRates.length === 'undefined')) {

                for (var rate in extra.includedRates) {
                    if (parseInt(rate) === roomRate) {
                        out.push(extra);
                    }
                }
            }
            else {
                out.push(extra);
            }
        });
        return out;
    };
    return extrasFilter;
}]);